<template>
  <v-container fluid></v-container>
</template>

<script>
export default {
  name: "Profile",
  route: {
    path: "/profile:uid",
    name: "Profile",
  },
};
</script>

<style></style>
